<template>
  <div class="advacedTable">
    <mq-layout :mq="['xs', '<xs']">
      <div class="mobileDiscription">
        <div
          class="mobileDiscription-flyout"
          v-bind:class="{ active: mobile.discriptionVisible === true }"
        >
          <a class="mobileDiscription-flyout-close" @click="hideMobileDiscription()">
            <Close>Close</Close>
          </a>

          <span class="mobileDiscription-flyout-label">What it can do for you</span>
          <br />

          <strong>
            {{ mobile.link + 1 }}&nbsp; &nbsp;{{
            data[mobile.row].label
            }}
          </strong>
          <br />
          {{ data[mobile.row].linkList[mobile.link] }}
          <br />
          <br />
          <br />
          <span v-html="data[mobile.row].discriptions[mobile.link]"></span>
        </div>
      </div>
      <table v-for="(row, i) in data" class="mobile">
        <thead>
          <tr>
            <th class="rowLabel">
              <strong>{{ row.label }}</strong>
            </th>
            <th class="rowLabel rowLabelMobilRight">Fields</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colspan="2">
              <span class="mobileSummery">
                <strong>→</strong>
                {{ row.summery }}
              </span>
              <br />
              <br />

              <a v-for="(link, index) in row.linkList" @click="showMobileDiscription(i, index)">
                <span>{{ link }}</span>
              </a>
            </td>
          </tr>
        </tbody>
      </table>
    </mq-layout>
    <mq-layout mq="s+">
      <table>
        <thead>
          <tr>
            <th></th>
            <th>Fields</th>
            <th>What it can do for you</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, i) in data" @mouseleave="showDiscription(i, -1)">
            <th class="rowLabel">
              <strong>{{ row.label }}</strong>
            </th>
            <td class="linkList">
              <a
                v-for="(link, index) in row.linkList"
                @mouseenter="showDiscription(i, index)"
                @click="showDiscription(i, index)"
              >
                <span>{{ link }}</span>
              </a>
            </td>
            <td class="discription">
              <p v-if="row.index > -1">
                <strong class="counter">{{ row.index + 1 }}</strong>
                <span v-html="row.discriptions[row.index]"></span>
              </p>
              <p v-if="row.index < 0">
                <strong>→</strong>
                {{ row.summery }}
              </p>
            </td>
          </tr>
        </tbody>
      </table>
    </mq-layout>
  </div>
</template>
<script>
import Close from "../Close.vue";

export default {
  name: "Highlight",
  components: {
    Close
  },
  props: {
    label: String
  },
  data: function() {
    return {
      currentSelction: -1,
      scrollTop: 0,
      mobile: {
        index: 0,
        link: 0,
        row: 0,
        discriptionVisible: false
      },
      data: [
        {
          index: -1,
          label: "Service design",
          linkList: [
            "Product design",
            "Graphic design",
            "Interaction design",
            "Social design",
            "Startegic managment",
            "Operations management",
            "Design ethnography"
          ],
          discriptions: [
            "We will design a product with service applications. Digital or analog, a product needs to integrate in your organization’s context, to accomplish your goals in efficiency, branding and customer satisfaction.",
            "We use beauty as a business advantage. Quality graphic design can provide your service with emotion and orientation. It makes information accessible and gives your service character.",
            "Together we create desirable and trustful interactions, that people like to share. To do so we need to find the perfect balance between usability, pleasurability und utility.",
            "To keep your organization relevant to the every changing needs of society, we open our design process to a more diverse group of people and even outsiders. Together we explore new ideas by using design thinking methodology.",
            "We have to translate the overall cooperate, business and operational strategy into a valuable product or service. This means, we have to find the balance between customer satisfaction and profits.",
            "We also need to design, manage and improve the process, through which our products and services are delivered.",
            "We should allow us, to build with an emphatic understanding of our users practices, routines and what he/she cares about. We use this valid understanding to work on better idea generations, concept development and implementation."
          ],
          summery: "Build products with social context"
        },
        {
          index: -1,
          label: "Design operations",
          linkList: [
            "Direction",
            "Influencing",
            "Optimization",

            "Operationalization"
          ],
          discriptions: [
            "Together, with your leaders, we form a vision for a design led organization and define our design strategy with focus on mission, goals, objectives and drive.",
            "To spread design awareness inside your organization, we search other drivers as allies, coach key business units, organize cross-departmental design gatherings and help solving peoples challenges with our design skills. ",
            "To scale and improve design quality, we integrate research in our work, shape new roles and collect the missing skills.",
            "We define, document and share knowledge, policies and tools to practice consistent design on a huge organizational scale - such as design systems, service manuals, design principles and methods."
          ],
          summery: "Build a sustainable product environment"
        },
        {
          index: -1,
          label: "Design engineering",
          linkList: [
            "UI / UX engineering",
            "Usability testing / MVP / Agile product development",
            "Creative Coding / Frontend development",
            "Design with AI context",
            "Calm technology",
            "Copenhagen Letter"
          ],
          discriptions: [
            "With interdisciplinary understanding we close the gap between  hidden ideas in a static design file and the true experience, often integrated from the perspective of pure functionality or efficiency.",
            "We think, test, iterate und implement, until we create the best offer for your audience and generate profits for your organization.",
            "We use coding as a powerful dynamic design tool, to test product ideas, expand your toolchain or build powerful emotions.",
            "We know that interaction patterns will change. Data and AI will improve the ability of products to predict our needs. Our goal is to build human / machine interactions that enrich people’s lives by connecting efficiency with empathy.",
            "We are smart people who can build technology, that will succeed because of its value for the user, rather than constantly screaming for attention or tricking people with dark patterns.",
            "As responsible people we shape todays technology based on the believes of the Copenhagen Letter. <br /> <br /> <ul class='advacedTable-list'><li>Tech is not above us</li>Progress is more than innovation.</li><li>Let us build from trust.</li><li>Design open to scrutiny.</li><li>Let us move from human-centered design to humanity-centered design.</li></ul> <br/> <a class='advacedTable-link' href='https://copenhagenletter.org/' target='blank_' >https://copenhagenletter.org/</a>"
          ],
          summery: "Build with ambition and principles"
        }
      ]
    };
  },
  methods: {
    showMobileDiscription(row, link) {
      this.mobile.discriptionVisible = true;
      this.mobile.link = link;
      this.mobile.row = row;
      this.scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      setTimeout(function() {
        document.body.classList.add("preventBackgroundScrolling");

        document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
      }, 200);
    },
    hideMobileDiscription(row, link) {
      this.mobile.discriptionVisible = false;
      document.body.classList.remove("preventBackgroundScrolling");
      document.documentElement.scrollTop = document.body.scrollTop = this.scrollTop;
    },
    showDiscription(i, index) {
      this.data[i].index = index;
    }
  }
};
</script>
<style scoped>
.advacedTable {
  padding-top: var(--LINE-HEIGHT);
  padding-bottom: calc(3 * var(--LINE-HEIGHT));

  margin-left: calc(var(--SPACE-LEFT) + var(--EXTRA-SPACE-LEFT));
  margin-right: var(--SPACE-RIGHT);
  overflow: hidden;
}

table {
  width: calc(var(--WIDTH) - var(--SPACE-LEFT) - var(--SPACE-RIGHT));
  line-height: 25px;
  font-size: 16px;
  margin-left: calc(var(--EXTRA-SPACE-LEFT) * -1);
}

table a {
  cursor: pointer;
  display: block;
  transition: var(--TRANSITION);
}
table a span {
  transition: var(--TRANSITION);
  text-decoration: underline;
}

table a:after {
  content: "→";
  opacity: 0;
  font-weight: bold;
}

table a:hover span {
  text-decoration-thickness: 2px;
}
table a:hover:after {
  content: "→";
  opacity: 1;
}
tr {
  transition: var(--TRANSITION);
}

td,
tbody th {
  vertical-align: top;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 15px;
  padding-bottom: 30px;
  border-top: 1px solid var(--BLACK);
  transition: var(--TRANSITION);
  /* height: 20vh; */
}

td:not(:last-child),
th.rowLabel {
  width: calc(var(--COLUMN-SIZE) * 2);
}

td,
thead th:not(:first-child) {
  border-left: 1px solid var(--BLACK);
}

thead th {
  padding-left: 15px;
  border-top: 0;
}

th.rowLabel {
  padding-left: var(--EXTRA-SPACE-LEFT);
  position: relative;
}

tr. .discription {
  /* font-style: italic; */
}

.counter {
  font-weight: bold;
  display: block;
  padding-bottom: var(--LINE-HEIGHT);
}

strong {
  font-weight: bold;
}

tr:last-child td {
  padding-bottom: 0;
}

@media only screen and (max-width: 576px) {
  td,
  tbody th {
  }

  tr:last-child td {
    padding-bottom: 30px;
  }

  th.rowLabel {
    padding-left: 25px;
  }

  .advacedTable {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
    border-bottom: 1px solid var(--BLACK);
    padding-bottom: 0;
    margin-bottom: calc(var(--LINE-HEIGHT) * 3);
  }
}

@media only screen and (min-width: 576px) and (max-width: 767px) {
  .advacedTable {
    margin-left: 0;
    margin-right: 0;
    width: 100%;
  }
  td,
  tbody th {
    height: auto;
  }

  th.rowLabel {
    width: 25%;
    padding-left: 25px;
  }
  td:not(:last-child) {
    width: 37%;
  }
  td:last-child {
    width: 37%;
  }
}

.mobile {
  margin-left: 0;
  margin-right: 0;
  width: 100%;
}
.mobile td,
.mobile th {
  border-left: 0;
  padding: 15px;

  padding-left: 25px;
}

.mobile th.rowLabelMobilRight {
  border-left: 0;
  text-align: right;
  padding-right: 25px;
  width: 20%;
}

.mobileDiscription {
  position: fixed;
  left: 0;
  right: 0;
  bottom: calc(var(--LINE-HEIGHT) * 4);
  top: 0;
  z-index: 1000;
  pointer-events: none;
}

.mobileDiscription-flyout {
  position: absolute;
  border-top: 1px solid var(--BLACK);
  left: 0;
  right: 0;
  top: 0%;
  bottom: 0;
  background-color: #fff;
  padding: 25px;
  padding-top: 50px;
  padding-bottom: 50px;

  line-height: var(--LINE-HEIGHT);
  overflow: scroll;
  pointer-events: all;
  transform: translateY(100%);
  scroll-behavior: smooth;
  opacity: 0;
}
.mobileDiscription-flyout.active {
  transform: translateY(0);
  opacity: 1;
}

.mobileSummery {
  padding-bottom: var(--LINE-HEIGHT);
}

.mobileDiscription-flyout-close svg {
  stroke: var(--BLACK);
  pointer-events: none;
}
.mobileDiscription-flyout-close {
  position: absolute;
  left: 25px;
  top: 15px;
}

.mobileDiscription-flyout-label {
  position: absolute;
  right: 25px;
  top: 25px;
}

/* manualy adjusted row 
heights to avoid jumping 
on mouseover for 
discriptions */
@media only screen and (min-width: 768px) and (max-width: 992px) {
  /* tbody tr:nth-child(1) td,
  tbody tr:nth-child(1) th {
  } */
  tbody tr:nth-child(2) td,
  tbody tr:nth-child(2) th {
    height: calc(var(--LINE-HEIGHT) * 6 + 50px);
  }
  tbody tr:nth-child(3) td,
  tbody tr:nth-child(3) th {
    height: calc(var(--LINE-HEIGHT) * 12 + 45px);
  }
}
@media only screen and (min-width: 992px) {
  /* tbody tr:nth-child(1) td,
  tbody tr:nth-child(1) th {
  } */
  tbody tr:nth-child(2) td,
  tbody tr:nth-child(2) th {
    height: calc(var(--LINE-HEIGHT) * 4 + 50px);
  }
  tbody tr:nth-child(3) td,
  tbody tr:nth-child(3) th {
    height: calc(var(--LINE-HEIGHT) * 11 + 45px);
  }
}

/* th.rowLabel:after {
  content: " ";
  height: 1px;
  background-color: var(--BLACK);
  position: absolute;
  top: -1px;
  left: auto;
  right: -100vw;

  width: 100vw;
  overflow: hidden;
} */
</style>
<style>
.advacedTable-list {
  list-style: disc outside !important;
  margin-left: 15px;
}

.advacedTable-link {
  color: inherit;
  line-height: var(--LINE-HEIGHT);
  text-decoration-thickness: 1px;
  text-decoration-width: 1px;
  transition: var(--TRANSITION);
  transition-property: text-decoration-color, text-decoration-thickness,
    text-decoration-width;
}

.advacedTable-link:hover {
  text-decoration-thickness: 3px;
}

.preventBackgroundScrolling {
  /* when modal active */
  touch-action: none;
  -webkit-overflow-scrolling: none;
  overflow: hidden;
  /* Other browsers */
  overscroll-behavior: none;
  /* position: fixed; */
}
</style>



// WEBPACK FOOTER //
// src/components/subpages/AdvancedTable.vue